var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.327,
    height: 88.327,
    viewBox: "0 0 88.327 88.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ed1c24;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.401 18.401)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.282,74.925H25.241c-2.576,0-5.52-2.208-5.52-6.624V60.572A12.78,12.78,0,0,0,14.937,51,25.44,25.44,0,0,1,5,30.394,26.191,26.191,0,0,1,30.394,5a25.865,25.865,0,0,1,18.4,7.361,26.2,26.2,0,0,1,7.729,18.4,24.751,24.751,0,0,1-9.569,19.873A13.437,13.437,0,0,0,41.8,60.94V69.4a5.66,5.66,0,0,1-5.52,5.52ZM30.762,8.68C18.985,8.68,9.048,18.617,8.68,30.394a21.633,21.633,0,0,0,8.465,17.665A16.038,16.038,0,0,1,23.4,60.572V68.3c0,.736,0,2.944,1.84,2.944H36.282a1.739,1.739,0,0,0,1.84-1.84V60.94a17.884,17.884,0,0,1,6.624-13.249,21.46,21.46,0,0,0,8.1-16.929,22,22,0,0,0-6.624-15.825A21.694,21.694,0,0,0,30.762,8.68Z",
    transform: "translate(-5 -5)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.122 73.605)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.241,23.68H10.84a1.84,1.84,0,0,1,0-3.68h18.4a1.84,1.84,0,0,1,0,3.68Z",
    transform: "translate(-9 -20)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.323)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.34,11.041A1.739,1.739,0,0,1,11.5,9.2V1.84A1.739,1.739,0,0,1,13.34,0a1.739,1.739,0,0,1,1.84,1.84V9.2A1.739,1.739,0,0,1,13.34,11.041Z",
    transform: "translate(-11.5)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.797 12.697)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.174,12.1a2.213,2.213,0,0,1-1.472-.368,1.779,1.779,0,0,1,0-2.576L23.854,4a1.779,1.779,0,0,1,2.576,0,1.779,1.779,0,0,1,0,2.576l-5.152,5.152a3.707,3.707,0,0,1-1.1.368Z",
    transform: "translate(-18.15 -3.45)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.286 42.323)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.2,15.18H22.84A1.739,1.739,0,0,1,21,13.34a1.739,1.739,0,0,1,1.84-1.84H30.2a1.739,1.739,0,0,1,1.84,1.84A1.739,1.739,0,0,1,30.2,15.18Z",
    transform: "translate(-21 -11.5)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 42.323)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.2,15.18H1.84A1.739,1.739,0,0,1,0,13.34,1.739,1.739,0,0,1,1.84,11.5H9.2a1.739,1.739,0,0,1,1.84,1.84A1.739,1.739,0,0,1,9.2,15.18Z",
    transform: "translate(0 -11.5)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.329 12.329)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.527,12.367A2.213,2.213,0,0,1,9.054,12L3.9,6.478A1.779,1.779,0,0,1,3.9,3.9a1.779,1.779,0,0,1,2.576,0l5.152,5.152a1.779,1.779,0,0,1,0,2.576c-.368.368-.736.736-1.1.736Z",
    transform: "translate(-3.35 -3.35)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionIcon);
export default __webpack_public_path__ + "static/media/missionIcon.14ae3fdbde56096598e7d65ef7bf0cc9.svg";
export { ForwardRef as ReactComponent };